var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body pt-2"},[_c('hr',{staticClass:"card-separator"}),_c('div',{staticClass:"mt-3 justify-content-center align-items-center d-flex"},[_c('button',{staticClass:"btn btn-sm btn-outline-danger border-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.emitClick()}}},[_vm._v("Annuler la reprise")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }